import ReactDOM from "react-dom";
import { DialogProps, DialogSize } from "./dialog.interface";
import times from "../../../assets/images/sidebar/Times.svg";
import { zIndexs } from "../../../interfaces/environment";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { DeviceEnum } from "../../../redux/slices/environmentSlice";
import { handleClearAllSelectedResources } from "../fileManagers/fileManager.actions";
import NameDisplay from "../displayFaEn/showCorrectName/showCorrectName.index";
import { ReactComponent as Trash } from "../../../assets/images/svg/trash-fill.svg";
import { shallowEqual } from "react-redux";

export default function Dialog(props: DialogProps) {
    const {
        status,
        onClose,
        closeButton = true,
        deleteDialog = false,
        size = DialogSize.SM,
        title,
        closeOnBlur,
        children,
        clearSelectedFiles,
        className,
        childrenParentClassName,
        icon,
        titleClssName
    } = props;
    const [kill, setKill] = useState(false);
    const [dialogStatus, setDialogStatus] = useState(false);
    const { device } = useAppSelector(({ environment: { device } }) => ({ device }), shallowEqual);

    useEffect(() => {
        window.addEventListener("popstate", () => {
            onClose();
        });
        return () => {
            window.removeEventListener("popstate", () => true);
        };
    }, []);

    useEffect(() => {
        if (!status) {
            setKill(true);
            setTimeout(() => {
                setDialogStatus(false);
                setKill(false);
            }, 500);
        } else {
            setDialogStatus(status);
        }
    }, [status]);

    return dialogStatus
        ? ReactDOM.createPortal(
              <div
                  className={`fixed flex flex-col items-center top-0 left-0 w-full h-full ${size !== DialogSize.FULL && "md:p-8"}`}
                  style={{ zIndex: zIndexs.otherModals }}
                  id="dialog"
              >
                  <div
                      id={"upload-link-url-backdrop-mobile"}
                      className={`fixed top-0 left-0 bg-black bg-opacity-70 w-full h-full animate__animated ${kill ? "animate__fadeOut animate__faster" : "animate__fadeIn"}`}
                      onClick={() => {
                          if (closeOnBlur) {
                              if (clearSelectedFiles) handleClearAllSelectedResources();
                              onClose();
                          }
                      }}
                  />
                  <div className="flex w-full h-full justify-center items-end md:items-center">
                      <div
                          className={`${className} !relative bg-white flex animate__animated max-h-full rounded-t-[20px] ${size} w-full
                        ${size === DialogSize.FULL ? "h-full" : "h-auto"}
                        ${size !== DialogSize.FULL && "md:rounded-b-[20px]"}
                        ${
                            kill
                                ? `
                        ${device === DeviceEnum.mobile ? "animate__slideOutDown animate__faster" : "animate__fadeOut animate__faster"}`
                                : `
                        ${device === DeviceEnum.mobile ? "animate__slideInUp animate__faster" : "animate__fadeIn"}`
                        }
                    `}
                          style={{ zIndex: zIndexs.otherModals + 1 }}
                          id={deleteDialog ? "dialog-background" : ""}
                      >
                          {dialogStatus && deleteDialog && (
                              <div className="absolute bg-red-500 text-center mx-3 left-0 right-0 bottom-[98%] h-[6px] rounded-t-[50px]"></div>
                          )}
                          {dialogStatus && deleteDialog && (
                              <div
                                  className={`right-[calc(50%-20px)] top-[-20px] animate__animated ${kill ? "animate__fadeOut animate__faster" : "animate__fadeIn"} flex items-center justify-center rounded-full absolute h-10 w-10 bg-red-600 z-[100000]`}
                              >
                                  <Trash fill={"white"} />
                              </div>
                          )}
                          <div className="flex flex-col flex-1 w-full overflow-hidden">
                              {(closeButton || title) && (
                                  <div className={`flex items-center gap-4 justify-between p-4 ${titleClssName}`}>
                                      <div className="flex items-center gap-2 truncate">
                                          {icon && <img src={icon} alt="icon" />}
                                          {title && (
                                              <h3 className="truncate text-[18px] font-[700] text-myDark">
                                                  <NameDisplay TextInput={title!} />
                                              </h3>
                                          )}
                                      </div>
                                      {closeButton && (
                                          <img
                                              src={times}
                                              alt="times"
                                              onClick={() => {
                                                  if (clearSelectedFiles) handleClearAllSelectedResources();
                                                  onClose();
                                              }}
                                              className="cursor-pointer"
                                          />
                                      )}
                                  </div>
                              )}
                              <div className={`overflow-auto no-scrollbar flex-1 ${childrenParentClassName}`}>{children}</div>
                          </div>
                      </div>
                  </div>
              </div>,
              document.getElementById("dialog-react-root")!
          )
        : null;
}
